<div [ngClass]="getLayoutClasses()" coreFreshdeskButton class="" >
    <ng-template #loading>
        <core-loader-fisherman></core-loader-fisherman>
    </ng-template>

    <div class="grid-wrapper" *ngIf="session != null else loading">
        <app-layout-overlapped-main></app-layout-overlapped-main>
        <div class="head" coreFreshdeskButton [user]="session.current.user">
            <core-layout-header [session]="session" (newOrganization)="changeOrg($event)"></core-layout-header>
        </div>
          <section class="main-section">
                <router-outlet></router-outlet>
          </section>
          <aside class="pin_navigation"></aside>
          <div class="foot">
              <core-layout-footer></core-layout-footer>
          </div>
    </div>
    <app-disconnected *ngIf="!logged"></app-disconnected>
    <div class="load-block" [ngClass]="{online: logged && session!=null}"></div>
</div>
